<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title> Export transactions </ng-container>
  <ng-container body>
    @if (!isLoading()) {
      <div>
        <div class="mb-3">
          <app-employees-select-multi
            [selectedEmployees]="selectedEmployees()"
            (selectionChanged)="updateEmployees($event)">
          </app-employees-select-multi>
        </div>
        <div class="mb-3">
          <label
            class="form-label"
            for="merchantField">
            Merchant
          </label>
          <input
            id="merchantField"
            type="text"
            [(ngModel)]="merchant"
            (ngModelChange)="updateMerchant($event)"
            class="form-control search-field"
            placeholder="Merchant" />
        </div>
        <div class="mb-3">
          <app-category-select-multi
            [selectedCategories]="selectedCategories()"
            (selectionChanged)="updateCategories($event)">
          </app-category-select-multi>
        </div>
        @for (group of filterGroups; track group; let groupIndex = $index) {
          <div class="mb-3">
            <div class="form-label">{{ group.filterLabel }}</div>
            @for (option of group.options; track option; let optionIndex = $index) {
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  [type]="option.type"
                  [name]="'exportGroup_' + groupIndex"
                  [id]="'exportGroup_' + groupIndex + '_option_' + optionIndex"
                  [checked]="option.checked"
                  (change)="selectOption(group.param, option, groupIndex, optionIndex)" />
                <label
                  class="form-check-label"
                  [for]="'exportGroup_' + groupIndex + '_option_' + optionIndex">
                  {{ option.label }}
                </label>
              </div>
            }
          </div>
        }
        <div class="form-check form-switch mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            name="allDates"
            [(ngModel)]="allDates"
            (ngModelChange)="updateAllDates($event)"
            id="allDateSwitch" />
          <label
            class="form-check-label pt-1"
            for="allDateSwitch">
            All time date
          </label>
        </div>
        @if (!allDates) {
          <div class="form-label">Date Range</div>
          <app-date-range-picker
            setMinMaxDateFor="exportTransactions"
            [fromDate]="fromDate"
            [toDate]="toDate"
            (toDateChange)="setToDate($event)"
            (fromDateChange)="setFromDate($event)">
          </app-date-range-picker>
        }
      </div>
    }
    <div class="row gy-3 offcanvas-buttons">
      <div class="col-12 col-sm-auto">
        <app-offcanvas-cancel-btn [returnUrl]="returnUrl"></app-offcanvas-cancel-btn>
      </div>
      <div class="col-12 col-sm-auto ms-sm-auto">
        <button
          (click)="onExport()"
          class="btn btn-primary">
          Export
        </button>
      </div>
    </div>
    @if (isLoading()) {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
